import {FC} from "react";
import {
	GridToolbarContainer,
	GridToolbarColumnsButton,
	GridToolbarFilterButton,
	GridToolbarDensitySelector,
	GridToolbarExport
} from "@mui/x-data-grid-pro";
import {Button, Tooltip, Box} from "@mui/material";
import {Add, Undo, Check} from "@mui/icons-material";
import {useSSTranslation} from "@/i18n/useSSTranslation";
import {makeStyles} from "tss-react/mui";

const useStyles = makeStyles()((_theme) => ({
	customToolbar: {
		display: "flex",
		gap: "10px",
		border: "0px solid"
	},
	gap: {
		flexGrow: 100
	}
}));

interface PlaylistEnrollmentsGridToolbarProps {
	selectedRows: number[];
	isPlaylistPublished: boolean;
	handleEnroll: (userIds: number[]) => void;
	handleUnenroll: (userIds: number[]) => void;
	handleMarkComplete: (userIds: number[]) => void;
}

export const PlaylistEnrollmentsGridToolbar: FC<PlaylistEnrollmentsGridToolbarProps> = ({
	selectedRows,
	isPlaylistPublished,
	handleEnroll,
	handleUnenroll,
	handleMarkComplete
}) => {
	const {t} = useSSTranslation();
	const {classes} = useStyles();
	const hasSelectedRows = selectedRows.length > 0;

	return (
		<GridToolbarContainer className={classes.customToolbar}>
			<GridToolbarColumnsButton
				placeholder={undefined}
				onPointerEnterCapture={undefined}
				onPointerLeaveCapture={undefined}
				onResize={undefined}
				onResizeCapture={undefined}
			/>
			<GridToolbarFilterButton {...({} as any)} />
			<GridToolbarDensitySelector
				placeholder={undefined}
				onPointerEnterCapture={undefined}
				onPointerLeaveCapture={undefined}
				onResize={undefined}
				onResizeCapture={undefined}
			/>
			<GridToolbarExport />
			<Box className={classes.gap} />
			<Tooltip
				title={
					!isPlaylistPublished
						? t(
							"playlist_draft_not_enrollment_description",
							"Please publish the playlist to enable user enrollments.",
						)
						: ""
				}
			>
				<span>
					<Button
						disabled={!hasSelectedRows || !isPlaylistPublished}
						onClick={() => handleEnroll(selectedRows)}
						data-test-id="playlist-enrollment-bulk-enroll-button"
						aria-label="Enroll selected employees in playlist"
						sx={{position: "relative"}}
					>
						<Add /> {t("common_enroll", "ENROLL")}
					</Button>
				</span>
			</Tooltip>
			<Tooltip
				title={
					!isPlaylistPublished
						? t(
							"playlist_draft_not_enrollment_description",
							"Please publish the playlist to enable user enrollments.",
						)
						: ""
				}
			>
				<span>
					<Button
						disabled={!hasSelectedRows || !isPlaylistPublished}
						onClick={() => handleUnenroll(selectedRows)}
						data-test-id="playlist-enrollment-bulk-unenroll-button"
						aria-label="Unenroll selected employees from playlist"
					>
						<Undo /> {t("common_unenroll", "UNENROLL")}
					</Button>
				</span>
			</Tooltip>
			<Tooltip
				title={
					!isPlaylistPublished
						? t(
							"playlist_draft_not_enrollment_description",
							"Please publish the playlist to enable user enrollments.",
						)
						: ""
				}
			>
				<span>
					<Button
						disabled={!hasSelectedRows || !isPlaylistPublished}
						onClick={() => handleMarkComplete(selectedRows)}
						data-test-id="playlist-enrollment-bulk-complete-button"
						aria-label="Mark selected employees as complete for playlist"
					>
						<Check /> {t("common_complete", "COMPLETE")}
					</Button>
				</span>
			</Tooltip>
		</GridToolbarContainer>
	);
};
